<template>
  <div class="enterprise">
      <!-- <keep-alive> -->
        <router-view></router-view>
      <!-- </keep-alive> -->
    <ContentView v-if="isDetail==false">
      <template slot="operateLeft">
        <el-button size="small" @click="addOrg" style="margin-right:10px;">添加企业</el-button>
        <el-input class="enter-input" v-model="searchVal" clearable  size="small" @keyup.enter.native="onSearch" placeholder="请输入企业名称">
          <!-- <el-button slot="append" @click="onSearch">搜索</el-button> -->
        </el-input>
        
        <!-- <el-select class="enter-input" v-model="value" size="small"  placeholder="请选择">
            <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select> -->
      </template>
      <template slot="operateRight"></template>
      <el-table slot="contentBox" height="100%" border :data="tableData" @sort-change="onTbaleSort" @row-click="onDetail" :header-cell-style="{}" style="width: 100%">
        <!-- <el-table-column prop="logoPath" label="LOGO" width="80">
          <template slot-scope="scope">
            <el-image class="org-logo" :src="scope.row.logoPath">
              <div slot="error" class="image-slot">
               <img class="org-logo" src="https://oss.sgitns.com/defaultimages/qylogo.png" alt="">
              </div>
            </el-image>
          </template>
        </el-table-column> -->
        <el-table-column sortable="custom" prop="orgCode" label="企业编号" width="110"></el-table-column>
        <el-table-column sortable="custom" prop="orgName" label="企业名称"></el-table-column>
        <el-table-column prop="orgName_Short" label="简称" width="140"></el-table-column>
        <el-table-column sortable="custom" prop="linkman" label="联系人" width="105"></el-table-column>
        <el-table-column sortable="custom" prop="contactNumber" label="电话" width="115"></el-table-column>
        <el-table-column sortable="custom" prop="orgType" label="企业类型" width="105">
           <template slot-scope="scope">
            <span>{{sjConfig.orgType[scope.row.orgType]}}</span>
          </template>
        </el-table-column>
         <el-table-column sortable="custom" prop="deviceCount" width="80" label="设备"></el-table-column>
        <el-table-column sortable="custom" prop="userCount" width="80" label="人员"></el-table-column>
         <el-table-column sortable="custom" prop="workOderCount" width="110" label="维修工单"></el-table-column>
        <el-table-column sortable="custom" prop="registrationDate" width="110" label="注册日期"></el-table-column>
        <el-table-column sortable="custom" prop="expireDate" width="110" label="到期日期"></el-table-column>
        <el-table-column width="70" label="状态">
          <template slot-scope="scope">
            <span>{{sjConfig.orgState[scope.row.orgState]}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column width="70" label="操作">
          <template slot-scope="scope">
           <el-button>停用</el-button>
           <el-button>启用</el-button>
          </template>
        </el-table-column> -->
      </el-table>
        <template slot="pagnation">
        <el-pagination
          background
          @size-change="pageSizeChange"
          @current-change="pageCurrentChange"
          :page-sizes="[15, 20, 30, 50]"
          :page-size="15"
          layout="sizes, prev, pager, next"
          :total="total"
        ></el-pagination>
      </template>
    </ContentView>
  </div>
</template>


<script>
import ContentView from "@/components/ContentView";
import apiPub from '@/api/public'
export default {
  name: "enterprise",
  data() {
    return {
      dialogFormVisible:false,
      form:{
        contactNumber: "",
        expireDate: "",
        id: "",
        linkman: "",
        logoPath: "",
        orgCode: "",
        orgName: "",
        orgName_Short: "",
        orgState: "",
        orgType: "",
        registrationDate: "",
      },
      formLabelWidth:"80px",
      tableData: [],
      options:[],
      searchVal:"",
      isDetail:false,
      input:"",
      win: false,
      value: "",
      OrdFild:"registrationDate",
      OrdSort:"desc",
      pageNum:15,
      page:1,
      total:0,
      timesRun: 0
    };
  },
  components: {
    ContentView
  },
  watch:{
    $route(to,from){
      // console.log(to);
      // this.controlRouter()
      if (to.name != 'enterprise') {
        this.isDetail = true;
      } else {
        this.isDetail = false;
        this.onSearch()
      }
    }
  },
  created() {
    this.onSearch()
    this.controlRouter()
    // this.init()
    // console.log(this.sjConfig)
    // console.log(process.env.BASE_URL)
  },
  methods: {
    //---------------查询区域--------begin-----------
    onSearch(){
      this.page = 1;
      this.total = 0;
      this.getlist()
    },
    //---------------业务区域--------end-----------
    controlRouter() {
      // console.log(this.$router.currentRoute)
       if (this.$router.currentRoute.name != 'enterprise') {
        this.isDetail = true;
      } else {
        this.isDetail = false;
      }
    },
    handleChange(){

    },

    //---------------表格操作--------begin-----------
    getlist(){
      var that=this;
      var SearchText=this.searchVal||""
      var obj = {
        "url": apiPub.GetAllEnterprise,
        "data":{
          pageNum: that.page - 1,
          pageSize: that.pageNum,
          SearchText:SearchText,
          OrdFild:that.OrdFild,
          OrdSort:that.OrdSort
        }
      };
      $http.request(obj,false,function(res) {
        // console.log(res)
        that.tableData=res.data;
        that.total=res.totalNum;
      })
    },
    navTo(){
      console.log(123)
    },
    addOrg(){
      this.$router.push({path: '/home/enterprise/orgDetail'});
    },
    onDetail(e){
       this.$router.push({path: '/home/enterprise/orgDetail', query: {id:e.id}});
       return;
        // console.log(e)
        //  this.$router.push({ name: "orgDetail" })
        // this.dialogFormVisible=true;
    },

    onTbaleSort(e){
        console.log(e)
        if(e.prop&&e.order){
          var sort={"descending":"desc","ascending":"asc"}
          this.OrdFild=e.prop;
          this.OrdSort=sort[e.order];
          if(e.prop=='orgName_Short'){
            this.OrdFild='orgCode'
          }
        }else{
          this.OrdFild="";
          this.OrdSort="";
        }
        this.page = 1;
        this.total = 0;
        this.getlist()
      },
    /// -----------------------分页--begin-----------------------------
    pageSizeChange(val) {
      var pageNum = `${val}`;
      this.pageNum = parseInt(pageNum);
      this.getlist();
    },
    pageCurrentChange(val) {
      var page = `${val}`;
      this.page = parseInt(page);
      this.getlist();
    },
    /// -----------------------分页--end-------------------------------
  }
};
</script>
<style scoped>
.enterprise {
  /* padding: 20px; */
  background: #fff;
}
.org-logo {
  width: 40px;
  height: 40px;
}
.enter-input{
    width: 250px;

}
.enter-input+.enter-input{
    margin-left: 15px;
}
.el-form-item{
    margin-bottom: 10px;
}
</style>
